import { useState, useEffect } from "react";
import API from "../../Common/API";
import { motion } from "framer-motion";
import TabButtonGroup from "../../Components/Tabs/TabButtonGroup";
import TabButton from "../../Components/Tabs/TabButton";
import TabGroup from "../../Components/Tabs/TabGroup";
import Tab from "../../Components/Tabs/Tab";
import Marquee from "react-fast-marquee";
import dummyPic from "../../Assets/Images/dummy.jpg-removebg-preview.png";
import mLogo from '../../Assets/Images/logo.jpeg'
import logo from '../../Assets/Images/logo.png'
import { useTranslation } from "react-i18next";

const SuccessStories = () => {
  const [loading, setLoading] = useState(true);
  const [stories, setStories] = useState([]);
  const [users, setUsers] = useState([]);
  const [tabValue, setTabValue] = useState(0);
  const {t} = useTranslation()

  useEffect(() => {
    setLoading(true);
    try {
      API.get("/user/getSuccessStories").then((happyRes) => {
        if (happyRes.status === 200) {
          setUsers(happyRes.data.data.users);
          setStories(happyRes.data.data.stories);
          setLoading(false);
        }
      });
    } catch (err) {
      console.log("Error in fetching success stories", err);
    }
  }, []);

  return (
    <>
      {loading ? (
       <motion.div className="w-full min-h-screen flex flex-col justify-center items-center">
          <div className="bg-primeColor flex flex-row w-72 py-2  h-full cursor-pointer">
        <img src={mLogo} height={50} width={50} className="mx-2"/>
                <img src={logo} height={100} width={200} alt="logo" />
            </div>
            <p>Loading please wait...</p>
       </motion.div>
      ) : (
        <motion.div className="relative w-full min-h-screen flex flex-col justify-start pt-20 bg-gray-100">
          {/* Collage Background */}
          {/* <motion.div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-20 z-10">
            <img src={bgScreen} alt="background pattern" className="w-full h-full object-cover"/>
            </motion.div> */}
          <div className="absolute top-0 left-0 w-full h-80 overflow-hidden">
            <div className="flex flex-row flex-wrap w-full h-full object-cover">
              {users?.map((user, idx) => (
                <img
                  key={idx}
                  src={user?.images[0]?.imageUrl || dummyPic}
                  alt="Happy Couple"
                  className="h-36 object-contain"
                />
              ))}
            </div>
            {/* Tint Overlay */}
            <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
              <h1 className="text-4xl md:text-5xl font-bold text-white drop-shadow-lg">
                {t('Success Stories')}
              </h1>
            </div>
          </div>

          {/* Description */}
          <div className="relative z-10 mt-80 flex flex-col items-center">
            <p className="text-lg text-center max-w-2xl px-4">
              {t('Here are some of the success stories from our happy couples who found their life partners through our platform. We are delighted to have played a part in their journey of love and companionship.')}
            </p>
            <p className="font-bold text-3xl py-5">
              <span className="text-primeColor">{users?.length}</span> &nbsp;
              {t('Happy Customers')}
            </p>
          </div>

          <motion.div className="w-full py-10">
            <TabButtonGroup>
              <TabButton
                index={0}
                id="happy"
                value={tabValue}
                setValue={setTabValue}
              >
                {t('Happy Customers')}
              </TabButton>
              <TabButton
                index={1}
                id="success"
                value={tabValue}
                setValue={setTabValue}
              >
                {t('Success Stories')}
              </TabButton>
            </TabButtonGroup>

            <motion.div className="py-10">
              <TabGroup value={tabValue}>
                <Tab index={0} value={tabValue}>
                  <Marquee
                    gradientColor="rgba(248,251,253,0.9)"
                    gradientWidth={"200px"}
                    gradient="white"
                  >
                    {users.map((user, index) => (
                      <motion.div
                        key={index}
                        className="cursor-pointer relative w-full h-full shadow-md p-6 flex flex-col"
                      >
                        <motion.div className="flex w-full flex-col items-center">
                          <img
                            src={user?.images[0]?.imageUrl || dummyPic}
                            alt={user?.firstName || "Happy Customer"}
                            className="h-40 w-40 object-contain mb-4"
                          />
                          <h2 className="text-xl text-primeColor font-semibold mb-2">
                            {user?.firstName}
                          </h2>
                          <h3 className="text-md font-medium mb-2">
                            {user?.surname}
                          </h3>
                        </motion.div>
                      </motion.div>
                    ))}
                  </Marquee>
                </Tab>
                <Tab index={1} value={tabValue}>
                  {/* Success Story Cards */}
                  <motion.div className="grid grid-cols-1 drop-shadow-md md:grid-cols-3 lg:grid-cols-3 gap-8 p-4 mt-8 w-full">
                    {stories.length > 0 ? stories.map((story, index) => (
                      <motion.div
                        key={index}
                        className="bg-white cursor-pointer relative rounded-lg shadow-md p-6 h-64 flex flex-col items-center space-between"
                      >
                        <motion.div className="flex flex-row gap-4 space-between items-center w-full">
                          <motion.div className="h-32 w-64">
                            <img
                              src={
                                story.imageUrl ||
                                "https://via.placeholder.com/150"
                              }
                              alt={`${story.brideName} & ${story.groomName}`}
                              className="h-32 w-64 object-contain mb-4"
                            />
                          </motion.div>
                          <motion.div className="flex flex-col">
                            <h2 className="text-xl font-semibold mb-2">
                              {story.brideName} & {story.groomName}
                            </h2>
                            <p className="text-gray-600 truncate overflow-hidden">
                              {story.story}
                            </p>
                          </motion.div>
                        </motion.div>
                        <motion.div className="mt-4 w-full absolute flex flex-row bottom-0 p-5 justify-between">
                          <motion.div className="flex flex-col">
                            <p>Wedding on</p>
                            <p className="text-primeColor font-bold">
                              {story?.weddingDate}
                            </p>
                          </motion.div>
                          <motion.div className="flex flex-col">
                            <p>Engagement on</p>
                            <p className="text-primeColor font-bold">
                              {story?.engagementDate}
                            </p>
                          </motion.div>
                        </motion.div>
                      </motion.div>
                    )) : <p className="col-span-3 text-center font-bold">No Success Stories Found</p>}
                  </motion.div>
                </Tab>
              </TabGroup>
            </motion.div>
          </motion.div>
        </motion.div>
      )}
    </>
  );
};

export default SuccessStories;
